/**
 * Reload the page once when a script from an older build is missing.
 *
 * Every deploy replaces the hashed files in /assets/. A visitor who loaded a
 * page before the deploy still holds the old HTML, so the next route change
 * asks for an old chunk and gets a 404. On 1 Oct 2026 Ahrefs saw this on 241
 * pages (old index-DngM7dGA.js). Without this script the page stops working
 * with no message.
 *
 * The script listens for the three ways the failure shows up: Vite's
 * vite:preloadError event, a failed <script> or <link> load under /assets/,
 * and a rejected dynamic import. It reloads at most once per 60 seconds, so
 * a file that is really missing cannot cause a reload loop.
 *
 * The optional HEIC library chunk (heic-to, quick quote photo step) is
 * excluded (7 Oct 2026). Its caller sends the original photo when the chunk
 * fails to load; a reload here would drop the visitor back to the address
 * step and lose the selected photos.
 */
export const STALE_CHUNK_RELOAD = `(function () {
  var KEY = "rh_stale_chunk_reload";
  function reloadOnce() {
    try {
      var last = Number(sessionStorage.getItem(KEY) || 0);
      if (Date.now() - last < 60000) return;
      sessionStorage.setItem(KEY, String(Date.now()));
    } catch (e) {}
    location.reload();
  }
  var OPTIONAL = /\\/assets\\/heic-to-/;
  window.addEventListener("vite:preloadError", function (event) {
    var p = event && event.payload;
    if (OPTIONAL.test(String((p && p.message) || p || ""))) return;
    if (event && event.preventDefault) event.preventDefault();
    reloadOnce();
  });
  window.addEventListener("error", function (event) {
    var t = event && event.target;
    var src = t && (t.src || t.href);
    if (src && /\\/assets\\/[^?#]+\\.(js|css)/.test(src) && !OPTIONAL.test(src) && (t.tagName === "SCRIPT" || t.tagName === "LINK")) reloadOnce();
  }, true);
  window.addEventListener("unhandledrejection", function (event) {
    var m = String((event && event.reason && event.reason.message) || "");
    if (OPTIONAL.test(m)) return;
    if (/dynamically imported module|Importing a module script failed|error loading dynamically imported module|Failed to fetch dynamically/i.test(m)) reloadOnce();
  });
})();`;
